var $ = require('../../../jCube');

exports.controlRadioGroup = {

    build: function(_data) {
        // console.log(_data);
        return $.assign({}, _data, {
            tagName: 'div',
            // name: null,
            // className: 'radio-group',
            container: {
                className: 'fb-radio-group'
            },
            render: this.render
        });
    },

    render: function(dom) {

        var radio, label, frame;

        if(!$.isEmptyValue('values', this)) {
            for (var i = 0; i < this.values.length; ++i){
                if(this.values[i] !== null) {
                    var item = this.values[i];
                    var _id = this.name + '-' + i;
                    frame = document.createElement('div');
                    frame.className = 'radio';

                    radio = document.createElement('input');
                    radio.setAttribute('type', 'radio');
                    radio.setAttribute('name', this.name);
                    radio.setAttribute('id', _id);
                    frame.appendChild(radio);

                    label = document.createElement('label');
                    label.htmlFor = _id;
                    label.innerHTML = item.label;
                    frame.appendChild(label);

                    dom.appendChild(frame);
                }
            }
        }

        return dom;
    }
};
